import './styles.css';
import Logo from '../images/logo.png';
import { Link } from 'react-router-dom';

function Header(props) {
  return (
    <div className="sub-header">
            <nav>
                <Link to="/"><img src={Logo} alt="" /></Link>
                <div class="nav-link" id="navLinks">
                    <i class="fa fa-times" onclick="hideMenu()"></i>
                    <ul>
                      <li><Link to="/">HOME</Link></li>
                      <li><Link to="/about">ABOUT</Link></li>
                      <li><Link to="/course">COURSE</Link></li>
                      {/* <li><Link to="/contact">CONTACT</Link></li> */}
                    </ul>
                </div>
                <i class="fa fa-bars" onclick="showMenu()"></i>
            </nav>
            
            <h1>{props?.title}</h1>
    </div>
  );
}

export default Header;
